export const getEnvVar = <T>(key: string): T | null => {
  let value: string | undefined;

  // If vitest or jest
  if (
    typeof process !== 'undefined' &&
    process.env.JEST_WORKER_ID !== undefined
  ) {
    // We are in jest
    value = process.env[key];
  } else if (import.meta) {
    // We are in vite or vitest
    value = (import.meta as any).env[key] as string | undefined;
  } else {
    return null;
  }
  return value ? (value as T) : null;
};
